
export const buildParameter = {
         SaveDetail: (id, formdata) => {
           let param = {
             TOPIC_ID: id,
             LOAD_TOPIC: formdata.LOAD_TOPIC,
             ACTIVE: formdata.ACTIVE
           };
           return param;
         },
       };
